<template>
  <v-dialog
    v-model="isOrderErrorSnackbarVisible"
    width="400"
    color="white black--text"
  >
    <v-card>
      <v-card-title class="orange lighten-3">
        <h2 class="text-h4 mt-3 mb-1">
          Your order could not be placed
        </h2>
      </v-card-title>

      <v-card-text class="pt-6 pb-8">
        <h3 class="text-h5">
          We apologize but there was an error placing your order. Try it again,
          but if you continue to see this message please
          <span v-if="getIsLiveChatEnabled"
            >click the help button below to speak to someone</span
          >
          <span v-else
            >reach out directly via email at
            <a
              :href="
                `mailto:${getContactEmail}?subject=Cannot Place Order on ${getShopTitle} (Customer id: ${getCustomerId})`
              "
              >{{ getContactEmail }}</a
            ></span
          >
          . Thank you.
        </h3>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="close" outlined color="grey darken-3"
          >Ok, Hide This</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'DialogOrderError',
  components: {},
  computed: {
    ...mapGetters('cart', ['getHasOrderError']),
    ...mapGetters('customer', ['getCustomerId']),
    ...mapGetters('shop', [
      'getIsLiveChatEnabled',
      'getContactEmail',
      'getShopTitle',
    ]),
    isOrderErrorSnackbarVisible: {
      get() {
        return this.getHasOrderError
      },
      set() {
        this.setOrderError(true)
      },
    },
  },
  methods: {
    ...mapActions('cart', ['setOrderError']),
    close() {
      this.setOrderError(false)
    },
  },
  data() {
    return {}
  },
}
</script>
